export const clienteData = {
    customer: {
        identifier: "adozindo-magalhaes-de-oliveira-neto",
        logo: "https://integrare-os-minio.nyr4mj.easypanel.host/sigas/logo-mini.png",
        logo_square: "https://integrare-os-minio.nyr4mj.easypanel.host/sigas/logo.png",
        name: "Positronic",
        footer_content: {
            endereco: "Avenida Xyz, 123 - Nazaré – Belém – Pará",
            extra: "Horário de Funcionamento: Segunda a Sexta de 9h às 17h",
            links: [
                {
                    label: "Link 1",
                    href: "#"
                },
                {
                    label: "Link 2",
                    href: "#"
                },
                {
                    label: "Link 3",
                    href: "#"
                }
            ],
            contatos: [
                "email@email.com",
                "(00) 00000-0000"
            ],
            copyright: "SIGAS Project"
        },
        created_at: "2024-11-04T14:17:32.882Z"
    }
}